// extracted by css-extract-rspack-plugin
export default {"root":"IIhy6Y","type":"cCcMAL","title-wrapper":"Aqo4vC","titleWrapper":"Aqo4vC","title":"Qf4KRy"};